<template>
    <div>
        <div class="search-block w-[90%] mx-auto">
            <div class="flex justify-between mt-2">
                <InputComponent :value="query" @update:modelValue="e => $emit('update:query', e)" placeholder="Пошук..." class="w-[250px]"/>
                <div v-if="currentAdminRole != 'supervisor'" class="filter w-[228px]">
                    <ButtonComponent @click="$emit('addScout')">Додати</ButtonComponent>
                </div>
            </div>
        </div>

        <div class="border-b-[1px] border-white w-[90%] mx-auto flex justify-end mt-[16px] mb-[16px]">
            <div class="text-white ml-[20px]">
                <span class="text-[28px] font-semibold">{{ scoutCount }}</span> лікарів
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'

export default {
    name: 'MenuBar',    

    props: {
        scoutCount: {
            type: Number,
            default: 0
        },

        query: {
            type: String,
            default: ''
        }
    },

    setup() {
        const currentAdminRole = ref(localStorage.getItem('userType'))

        return {
            currentAdminRole
        }
    }
}
</script>

<style>
    
</style>